import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import SearchResultCard from "./SearchResultCard";
import { Language } from "../../App";
import { resolveAgendaImageUrl } from "../../utils/agendaUtils";
import { _imagesURL } from "../../constants/API";
import defaultAgenda1 from "../../assets/images/default_agenda_1.jpg";
import Avatar from "../../assets/images/icon/placeholder_Awatar.png";
import {
  LuVideo,
  LuCalendar,
  LuClock,
  LuArrowRight,
  LuTv,
} from "react-icons/lu";

export function WebinarCard({ item }) {
  const { lang } = useContext(Language);
  const navigate = useNavigate();

  const cleanId = item?.id ? String(item.id).replace(/^(evt-|webinar-|session-)/i, "") : "";
  const coverImage = item?.image || item?.thumbnail || item?.media?.[0] || item?.cover;
  const coverUrl = resolveAgendaImageUrl(coverImage, defaultAgenda1);

  const title = item?.title || item?.name || "Medical Webinar";
  const dateStr = item?.schedule_date || item?.start_date || item?.date || "";
  const timeStr = item?.schedule_time || item?.start_time || item?.time || "";

  const hostName =
    item?.user?.name ||
    [item?.user?.firstname, item?.user?.lastname].filter(Boolean).join(" ") ||
    item?.host_name ||
    item?.host ||
    item?.creator_name ||
    "Doctor";

  const hostAvatar = resolveAgendaImageUrl(item?.user?.image, Avatar);

  const isLive = Boolean(
    item?.status === 1 ||
    item?.status === "1" ||
    item?.is_live ||
    item?.isLive
  );

  return (
    <div
      className="search-agenda-card-compact"
      onClick={() => navigate(`/webinar-details/${cleanId || item?.id}`)}
    >
      <div className="search-agenda-thumb-wrap">
        <img
          src={coverUrl}
          alt={title}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = defaultAgenda1;
          }}
        />
        <span
          className="search-agenda-type-badge"
          style={{
            background: isLive ? "rgba(220, 38, 38, 0.85)" : undefined,
          }}
        >
          {isLive ? (lang?.live || "LIVE") : (lang?.webinar || "Webinar")}
        </span>
      </div>

      <div className="search-agenda-content">
        <h4 className="search-agenda-title" title={title}>
          {title}
        </h4>

        <div className="search-agenda-meta-row">
          {dateStr && (
            <span className="search-agenda-meta-item">
              <LuCalendar size={13} />
              <span>{dateStr}</span>
            </span>
          )}
          {timeStr && (
            <span className="search-agenda-meta-item">
              <LuClock size={13} />
              <span>{timeStr}</span>
            </span>
          )}
        </div>

        <div className="search-agenda-footer">
          <div className="search-agenda-host-info">
            <img
              src={hostAvatar}
              alt={hostName}
              className="search-agenda-host-avatar"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = Avatar;
              }}
            />
            <span className="search-agenda-host-name">{hostName}</span>
          </div>

          <span className="search-agenda-btn-action">
            <span>{isLive ? (lang?.join_live_webinar || "Join Live") : (lang?.view_webinar || "View Webinar")}</span>
            <LuArrowRight size={13} />
          </span>
        </div>
      </div>
    </div>
  );
}

export default function WebinarResultComp({ data, keyword, loading }) {
  const { lang } = useContext(Language);

  if (!loading && (!data || data.length === 0)) {
    return null;
  }

  return (
    <SearchResultCard
      id="webinars"
      icon={<LuVideo />}
      title={lang?.webinars || "Webinars"}
      count={data?.length}
      link={`/search/webinars?keyword=${encodeURIComponent(keyword || "")}`}
      seeAll={!loading && data?.length > 2}
    >
      {loading ? (
        <div className="search-agenda-grid">
          {[1, 2].map((n) => (
            <div key={n} className="search-agenda-card-compact">
              <div className="search-agenda-thumb-wrap search-shimmer-box" style={{ width: "100%", height: "140px" }} />
              <div className="search-agenda-content">
                <div className="search-shimmer-box mb-2" style={{ height: "16px", width: "80%" }} />
                <div className="search-shimmer-box mb-3" style={{ height: "13px", width: "60%" }} />
                <div className="d-flex align-items-center justify-content-between pt-2 border-top">
                  <div className="d-flex align-items-center gap-2">
                    <div className="search-shimmer-box rounded-circle" style={{ width: 22, height: 22 }} />
                    <div className="search-shimmer-box" style={{ height: 11, width: 65 }} />
                  </div>
                  <div className="search-shimmer-box" style={{ height: 12, width: 60 }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : data && data.length > 0 ? (
        <div className="search-agenda-grid">
          {data.slice(0, 2).map((item, index) => (
            <WebinarCard key={item?.id || index} item={item} />
          ))}
        </div>
      ) : (
        <div className="search-empty-state-card">
          <div className="search-empty-icon-wrap">
            <LuTv />
          </div>
          <h5 className="search-empty-title">{lang?.no_webinars_found || "No webinars found"}</h5>
          <p className="search-empty-desc">
            {lang?.try_different_keyword || "Try a different keyword or check spelling."}
          </p>
        </div>
      )}
    </SearchResultCard>
  );
}
